<template>
    <div id="page-container-white">
        <Appbar/>
         <div class="jumbotron jumbotron-fluid" id="page-container-red">
        <div class="container">
            <div class="row text-center jumbotext">
            <div class="col-12">
                    <h1 class="text-white ">WORLD's LARGEST FREE TRADE AREA </h1>
            </div>
            </div>
        </div>
        </div>
    <div class="container">
        <div class="row justify-content-center">
            <Spinner v-if="isLoading" :color="'text-danger'" />
           <div class="col-md-10 my-3" v-if="!isLoading">
               <button style="float:right" @click="verifyUser" class="btn myBtn 
                 mt-3" data-toggle="modal" data-target="#exampleModal">Create new Article</button>
           </div>
           
            <div class="col-md-10" v-if="!isLoading">
                <div class="row pb-4">
                    <div class="col-12 pb-4" v-for="(article,key) in articles" :key="key">
                        <div class="card">
                       <div class="card-header">
                            <h5 class="card-title"><strong style="font-style:italic">TITLE:</strong>
                            {{article.topic}}
                            </h5>
                       </div>
                        <div class="card-body">
                           
                            <p class="card-text">{{article.body.substring(0,500)}}
                                <router-link :to="`/article/${article.id}`" class="float-right">Read more...</router-link>
                            </p>
                            <p>Comments {{`[${article.comments.length}]`}}</p>
                            
                        </div>
                        </div>
                    </div>

                      <!-- <a href="#" class="text-danger">Load more articles <i class="fa fa-arrow-right" aria-hidden="true"></i></a> -->
                </div>
            </div>
        </div>
    </div>
    <FinalFooter />
     <!-- Modal -->
     <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle">New Article</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-success" v-if="success">
                            <p>Thank you for submitting your debate article with us.</p>
                            <p>Our team will review and if it meets our standard, it will be approved</p>
                        </div>
                        <form v-else>
                        <div class="form-group">
                            <label for="topic">Topic<strong class="text-danger">(required)</strong></label>
                            <input type="text" class="form-control" placeholder="Enter debate title"  required v-model="title">
                        </div>
                         <div class="form-group">
                           <label for="basic-url">Upload your picture (optional)</label>
                            <div class="custom-file">
                            <input accept="image/*" type="file" class="custom-file-input" id="validatedCustomFile" @change="uploadImage" >
                            <label class="custom-file-label" for="validatedCustomFile">
                               {{picTitle ? picTitle :"Choose file..."}}
                            </label>
                            <small v-if="error"  class="form-text text-danger">your picture size shouldn't be more than 1MB</small>
                        </div>
                       </div>
                            <div class="form-group">
                                <label for="description">Body <strong class="text-danger">(required)</strong></label>
                                <textarea  name="description" 
                                    class="form-control" rows="15" required placeholder="Enter Body" v-model="body">
                                    </textarea>
                            </div>
                        </form>
                    </div>
                   <div class="modal-footer">
                    <button type="button" class="btn btn-warning" data-dismiss="modal">Close</button>
                    <button @click="addArticle" v-if="title && body " type="submit" class="btn btn-success">Submit</button>
                 </div>
                    </div>
                </div>
                </div>
           </div>
</template>

<script>
import toaster from '../mixins/toasterMinxin'
import Appbar from './appBar'
import FinalFooter from '../components/FinalFooter'
import url from '../helpers/url'
import service from '../helpers/service'
import Spinner from '../components/Spinner'
    export default {
        components:{
            Appbar,
            FinalFooter,
            Spinner
        },
        data() {
            return {
                title:'',
                body:'',
                pic:'',
                picTitle:'',
                isLoading:false,
                success:false,
                error:false
            }
        },
        methods: {

             uploadImage(event) {
                this.pic = event.target.files
                this.picTitle = this.pic[0].name   
            },
            verifyUser() {
                const user = this.$session.get('entity')
                if(!user) {
                    window.location.replace(`/redirect?service=login`)
                }
             },
            addArticle(){
                this.success = false
                const formData = new FormData()
                if(this.pic) {
                    let size
                    for( let i = 0; i < this.pic.length; i++) {
                       size  = Math.round(( this.pic[i].size  / 1024)); 
                    }
                    if( size > 2048) {
                        this.error = true
                        this.toast({
                            message:'picture Size is too big',
                            type:'error'
                        })
                        return;
                    }
                    
                }
                if(this.pic) {
                    for( let i = 0; i < this.pic.length; i++) {
                        formData.append('pic', this.pic[i])
                    }
                } else {
                    formData.append('pic', '')
                }
                formData.append('topic', this.title)
                formData.append('body',this.body)
               
                this.$store.dispatch('addArticle', formData).then(response => {
                    if(response ) {
                        this.title = null
                        this.body = null
                        this.toast({
                            message:'Article added successfully.',
                            type:'success'
                        })
                    }
                    this.success = true
                }).catch(err => {
                     console.log(err)
                    if(err?.response?.data == undefined) {
                      
                        this.toast({
                            message:'Network error. Check network connection and try again.',
                            type:'error'
                        })
                    }
                })
            },
            fetchApprovedArticle() {
                this.isLoading = true
                this.$store.dispatch('fetchApprovedArticle')
                    .then(response => {
                        // console.log(response.data)
                        if(response) {
                            this.isLoading = false
                        }
                    })
                    .catch(err => {
                         this.isLoading = false
                        if(err?.response?.data == undefined) {
                        this.toast({
                            message:'Network error. Check network connection and try again.',
                            type:'error'
                        })
                    }
                    })
            }
        },
        computed:{
            articles() {
               return this.$store.getters.articles
            }
        },
        created() {
            this.fetchApprovedArticle()
        }
    }
</script>

<style  scoped>
.myBtn{
    background-color:#ba2428;
    padding:1em 2em;
    color:#fff;
    text-decoration: none;
    border: 1px solid #ba2428;
    transition: all 0.5s;
}
a{
    color:#ba2428;
}
.card-header{
    color:#fff;
    background-color:#ba2428;
}
 .jumbotron{
    background:url('../assets/AFCFTA  HEADER ARTICLES.jpg');
    background-size:cover;
    height:300px;
    margin-top:-75px;
    
    }
    .jumbotext{
        margin-top:120px
    }
      @media screen and (max-width: 600px) {
       h1 {
           font-size: 1.8em;
           margin-top:50px;
       }
   }
</style>